import { c as _c } from "react/compiler-runtime";
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu';
import type { SB_HeaderMenuItemProps } from '~/storyblok/components/types.generated';
import { SubMenuItem } from './WebMobileSubMenuItem';
type SubMenuContentProps = {
  item: SB_HeaderMenuItemProps;
  children?: React.ReactNode;
};
export const SubMenuContent: React.FC<SubMenuContentProps> = props => {
  const $ = _c(5);
  if (!props.item.layout) {
    return;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      SUBNAV_SPOTLIGHT: SubMenuContentList,
      SUBNAV_COLS: SubMenuContentRows,
      SUBNAV_ITEMS: SubMenuContentItems
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const mapping = t0 as const;
  const Component = mapping[props.item.layout];
  let t1;
  if ($[1] !== Component || $[2] !== props.children || $[3] !== props.item) {
    t1 = <Component item={props.item}>{props.children}</Component>;
    $[1] = Component;
    $[2] = props.children;
    $[3] = props.item;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const SubMenuContentList: React.FC<SubMenuContentProps> = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.item.subNavItems) {
    t0 = props.item.subNavItems?.map(_temp);
    $[0] = props.item.subNavItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <NavigationMenuPrimitive.List className="mt-7 flex flex-col gap-15 pb-[180px] text-base font-medium leading-6">{props.children}{t0}</NavigationMenuPrimitive.List>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const SubMenuContentRows: React.FC<SubMenuContentProps> = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.item.subNavItems) {
    t0 = props.item.subNavItems?.map(_temp2);
    $[0] = props.item.subNavItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <NavigationMenuPrimitive.List className="mt-7 grid grid-cols-[auto_1fr_1fr] gap-x-6 gap-y-10 px-6 pb-[180px] text-base font-medium leading-6">{props.children}{t0}</NavigationMenuPrimitive.List>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
const SubMenuContentItems: React.FC<SubMenuContentProps> = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.item.subNavItems) {
    t0 = props.item.subNavItems?.map(_temp3);
    $[0] = props.item.subNavItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <NavigationMenuPrimitive.List className="mt-7 grid grid-cols-[auto_1fr_1fr] gap-x-6 gap-y-10 px-6 pb-[180px] text-base font-medium leading-6">{props.children}{t0}</NavigationMenuPrimitive.List>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(subItem) {
  return subItem.title && <SubMenuItem key={subItem._uid} force="list-col" item={subItem} />;
}
function _temp2(subItem) {
  return subItem.title && <SubMenuItem key={subItem._uid} force="block" item={subItem} />;
}
function _temp3(subItem) {
  return subItem.title && <SubMenuItem key={subItem._uid} force="icon-block" item={subItem} />;
}